
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"14","height":"14","x":"1.5","y":"1.5","fill":"#C5151D","rx":"7"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linejoin":"round","d":"m10.775 6.225-4.55 4.55m0-4.55 4.55 4.55"}})])
          )
        }
      }
    